import { render } from "./RegistrationOrder.vue?vue&type=template&id=d9df399a&scoped=true"
import script from "./RegistrationOrder.vue?vue&type=script&lang=js"
export * from "./RegistrationOrder.vue?vue&type=script&lang=js"

import "./RegistrationOrder.vue?vue&type=style&index=0&id=d9df399a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9df399a"]])

export default __exports__